import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getAuth } from "@firebase/auth";
import { toggleWishlistApi, wishlistApi } from "../../../Apis/ProductApi";
import { UserAuthContext } from "../../../App";
import { allProductByTagsAPI } from "../../../Apis/ProductApi";
import { getStoresApi } from "../../../Apis/StoreApi";
import { createInquiryApi } from "../../../Apis/EnquiryApi";
import { CurrencyContext } from "../../../provider/CurrencyProvider";
import {
  FeaturedProductPriceTagSVG,
  FeaturedProductSendInquirySVG,
  FeaturedProductSendTickSVG,
  FeaturedProductsRatingSVG,
} from "../../../assets/svg/allSvg";

const FeatureSlide = () => {
  const auth = getAuth();
  const { userUid } = useContext(UserAuthContext);
  const [showForm2, setShowForm2] = useState(false);
  const [showForm3, setShowForm3] = useState(false);
  const navigate = useNavigate(); // Add this line to use the useNavigate hook
  const [allProductsData, setAllProductsData] = useState([]);
  const [screenSize, setScreenSize] = useState("lg"); // Default to large screen
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [wishlistData, setWishlistData] = useState([]);
  const [storeDetails, setStoreDetails] = useState({});
  const [showInquiryForm, setShowInquiryForm] = useState(false);
  const [inquiryContact, setInquiryContact] = useState(
    userUid?.currentUser?.uid ? userUid?.currentUser?.phoneNumber : ""
  );
  const [inquiryEmail, setInquiryEmail] = useState(
    userUid?.currentUser?.uid ? userUid?.currentUser?.email : ""
  );
  const [inquiryContent, setInquiryContent] = useState("");
  const [inquiryQuantity, setInquiryQuantity] = useState("");
  const [refresh, setRefresh] = useState(false);

  const { calculatedPrice, getCurrencySymbol } = useContext(CurrencyContext);

  // get data for wishList
  const getWhishData = async () => {
    const response = await wishlistApi(userUid?.currentUser?.uid);
    setWishlistData(response?.wishList?.wishlistJson);
  };

  // logged in user
  useEffect(() => {
    if (userUid?.currentUser?.uid) getWhishData();
  }, [refresh]);

  // fetch all Products by the tags and show
  const getProductsData = async () => {
    try {
      const response = await allProductByTagsAPI("featured");
      if (response?.products?.length > 0) {
        let maxProducts;

        // Determine the number of products to display based on screen size
        if (screenSize === "lg") {
          maxProducts = 4;
        } else if (screenSize === "md") {
          maxProducts = 3;
        } else {
          maxProducts = 2; // Display 2 products on smaller devices
        }
        const products = response.products.slice(0, maxProducts);
        const wishlistProductIDs = new Set(wishlistData);

        const updatedProducts = products.map((product) => ({
          data: product,
          liked: wishlistProductIDs.has(product.productID),
        }));

        setAllProductsData(updatedProducts);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  useEffect(() => {
    // Update screenSize based on window width
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setScreenSize("lg");
      } else if (window.innerWidth >= 768) {
        setScreenSize("md");
      } else {
        setScreenSize("sm");
      }
    };

    // Initial check and add event listener
    handleResize();
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    getProductsData();
  }, [wishlistData?.length, screenSize]);

  // useEffect(() => {
  //   getProductsData();
  // }, [wishlistData?.length]);

  const getStoreDetails = async (storeID) => {
    try {
      const storeResponse = await getStoresApi(storeID);
      if (storeResponse && storeResponse?.store) {
        setStoreDetails(storeResponse.store);
      } else {
        console.error("Error fetching store details:", storeResponse);
      }
    } catch (error) {
      console.error("Error fetching store details:", error);
    }
  };

  // ... rest of your component code ...

  const handleViewAllInquiries = () => {
    navigate("/orders/inquiry"); // Redirect to inquiries page
  };

  const toggleNextButton = () => {
    const user = auth.currentUser;
    if (!user) {
      navigate("/login");
      return;
    }

    setShowForm2(true);
    setShowForm3(false);
  };

  const handleCloseInquiryForm = () => {
    setShowInquiryForm(false);
    setSelectedProduct(null);
  };

  const handleCloseInquirySent = () => {
    setShowForm3(false);
  };

  const toggleSubmitButton = async () => {
    // alert("Enquiry Created Successfully");
    await createInquiryApi(
      selectedProduct.productID,
      userUid?.currentUser?.uid,
      selectedProduct.storeID,
      inquiryContact,
      inquiryQuantity,
      inquiryEmail,
      inquiryContent
    );
    setShowForm2(false);
    setShowForm3(true);

    setInquiryContact("");
    setInquiryQuantity("");
    setInquiryEmail("");
    setInquiryContent("");
  };

  const toggleBackToProductButton = () => {
    setShowForm2(false);
    setShowForm3(false);
  };

  const handleToggleLike = async (productId, liked) => {
    const user = auth.currentUser;
    if (!user) {
      navigate("/login");
      return;
    }

    await toggleWishlistApi(userUid?.currentUser?.uid, productId, !liked);
    setRefresh(!refresh);
  };

  const [sliceEnd, setSliceEnd] = useState(59); // Default slice for larger screens

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setSliceEnd(35); // Slice to 35 characters for smaller devices
      } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
        setSliceEnd(30); // Slice to 30 characters for medium devices
      } else {
        setSliceEnd(59); // Slice to 59 characters for larger devices
      }
    };

    // Initial check and add event listener
    handleResize();
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div className="lg:w-[1241px] max-w-auto mx-auto mt-[24px] px-[16px] md:px-[24px] h-[310px] md:h-[432px] lg:h-[577px] lg:px-0 flex flex-col">
        <div className="w-[131px] h-[21px] md:w-[169px] md:h-[30px] font-semibold text-[14px] md:text-[18px] lg:text-[20px] lg:w-[187px] text-[#000000] select-none">
          Featured
        </div>
        <hr className="bg-[#FF8100] w-[147px] md:w-[200px] lg:w-[263px] h-[4px] rounded-full mt-[8px] md:mt-[10px]" />
        <div className="lg:w-[1241px] max-w-auto mx-auto md:w-[720px] w-[328px] h-[263px] md:h-[372px] lg:h-[510px] md:bg-white rounded-[10px] mt-[13px] md:mt-[16px] lg:mt-[23px] md:shadow-[0_0px_0px_1px_rgba(0,0,0,0.07)] flex flex-row items-center justify-center gap-x-[20px] md:gap-x-[27px]">
          {allProductsData?.length > 0 ? (
            allProductsData?.map((products, index) => (
              <div
                key={index}
                className="bg-white shadow-[0_0px_0px_1px_rgba(0,0,0,0.07)] w-[154px] h-[263px] lg:w-[260px] lg:h-[418px] md:w-[177px] md:h-[316px] rounded-[10px] cursor-pointer"
              >
                <div className="flex flex-col w-[154px] h-[263px] md:w-[177px] md:h-[316px] lg:w-[260px] lg:h-[418px]">
                  <div className="w-[154px] h-[110px] md:w-[177px] md:h-[147px] lg:w-[260px] lg:h-[224px] flex items-center justify-center bg-[#F2F2F2] md:bg-transparent rounded-t-[10px] md:rounded-t-[12px] lg:rounded-t-[10px]">
                    <button className="relative md:w-[161px] md:h-[128px] lg:w-[229px] lg:h-[187px]">
                      <img
                        src={products?.data?.images[0]}
                        className="w-[137px] h-[90px] md:w-[161px] md:h-[128px] lg:w-[230px] md:rounded-[10px] lg:h-[187px] md:mb-0 object-cover"
                        alt=""
                        onClick={() => {
                          // console.log(item);
                          navigate(`/productId/${products?.data?.productID}`, {
                            state: products?.data?.productID,
                          });
                        }}
                      />
                      <div
                        onClick={() =>
                          handleToggleLike(
                            products?.data?.productID,
                            products?.liked
                          )
                        }
                        className={`absolute top-4 right-4 bg-white rounded-full w-[22px] h-[22px] flex items-center justify-center cursor-pointer" ${
                          products?.liked ? "bg-red-500" : "bg-white"
                        }`}
                      >
                        <svg
                          width="14"
                          height="12"
                          viewBox="0 0 14 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7 11.5725C6.87426 11.5725 6.76786 11.529 6.6808 11.442L2.15402 7.07478C2.10565 7.03609 2.03916 6.97321 1.95452 6.88616C1.86988 6.79911 1.73568 6.64072 1.5519 6.41099C1.36812 6.18127 1.20368 5.9455 1.05859 5.70368C0.913504 5.46187 0.784133 5.16927 0.67048 4.82589C0.556827 4.48251 0.5 4.14881 0.5 3.82478C0.5 2.76079 0.807106 1.92894 1.42132 1.32924C2.03553 0.729539 2.8843 0.429688 3.96763 0.429688C4.26748 0.429688 4.57338 0.481678 4.88532 0.585658C5.19727 0.689639 5.48744 0.829892 5.75586 1.00642C6.02427 1.18294 6.25521 1.34859 6.44866 1.50335C6.64211 1.65811 6.82589 1.82254 7 1.99665C7.17411 1.82254 7.35789 1.65811 7.55134 1.50335C7.74479 1.34859 7.97573 1.18294 8.24414 1.00642C8.51256 0.829892 8.80273 0.689639 9.11468 0.585658C9.42662 0.481678 9.73251 0.429688 10.0324 0.429688C11.1157 0.429688 11.9645 0.729539 12.5787 1.32924C13.1929 1.92894 13.5 2.76079 13.5 3.82478C13.5 4.8936 12.9462 5.98177 11.8387 7.08929L7.3192 11.442C7.23214 11.529 7.12574 11.5725 7 11.5725Z"
                            fill={products?.liked ? "#FF3E3E" : "#D3D3D3"}
                          />
                        </svg>
                      </div>
                      <div className="hidden py-[5px] px-[6px] w-[67px] h-[28px] bg-white rounded-[5px] md:flex items-center justify-center gap-x-[3px] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)] absolute top-36 right-4 md:top-[100px] md:absolute md:right-[10px] lg:top-36 lg:right-4">
                        {FeaturedProductsRatingSVG}
                        <p className="w-[40px] h-[18px] font-semibold text-[12px] text-black">
                          4.2 / 5
                        </p>
                      </div>
                    </button>
                  </div>
                  <div className="hidden md:block md:px-[8px] lg:px-[15px]">
                    <hr className="w-full h-[1px] bg-white" />
                  </div>
                  <div className="w-[154px] h-[152px] md:w-[177px] md:h-[167px] lg:w-[260px] lg:h-[193px] pt-[14px] px-[10px] pb-[10px] md:pt-[12px] md:px-[8px] md:pb-[8px] lg:pt-[10px] lg:px-[15px] lg:pb-[20px] flex flex-col rounded-b-[10px] md:rounded-b-[12px] lg:rounded-b-[10px]">
                    <button className="text-left">
                      <p className="w-full h-[21px] md:w-full md:h-[24px] font-semibold text-[14px] md:text-[16px] mb-[5px] md:mb-0 lg:mb-[13px]">
                        {products?.data?.productTitle?.slice(0, 12)}...
                      </p>
                    </button>
                    <p className="w-full h-[18px] lg:h-[21px] font-semibold text-[12px] lg:text-[14px] mb-[8px] md:mb-[12px] lg:mb-[10px]">
                      {getCurrencySymbol()}{" "}
                      {calculatedPrice(products?.data?.maxPrice)}
                    </p>
                    <p className="w-full h-[34px] md:h-[42px] lg:h-[48px] text-[12px] md:text-[14px] mb-[9px] md:mb-[12px] lg:mb-[6px]">
                      {products?.data?.shortDesc?.slice(0, sliceEnd)}...
                    </p>
                    <button
                      className="w-[134px] h-[32px] md:w-[161px] md:h-[40px] lg:w-[229px] lg:h-[41px] flex items-center justify-center bg-[#FF6300] rounded-[5px]"
                      onClick={() => {
                        setSelectedProduct(products?.data);
                        toggleNextButton();
                      }}
                    >
                      <div className="flex items-center justify-center text-white gap-x-[5px] lg:gap-x-[8px]">
                        {FeaturedProductSendInquirySVG}
                        <p
                          className="font-medium text-[12px] text-white w-[80px] h-[18px] lg:w-[110px] lg:h-[24px] md:w-[120px] md:h-[24px] md:font-medium md:text-[16px]"
                          onClick={toggleNextButton}
                        >
                          Send Enquiry
                        </p>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="flex items-center justify-center text-gray-500">
              Coming Soon.....
            </div>
          )}
        </div>
        {showForm2 && selectedProduct && (
          <>
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <div className="bg-white rounded-[10px] w-[869px] h-[657px] flex flex-col">
                <div className="w-full h-[202px] bg-[#F8F8F8] rounded-t-[10px] pt-[24px] px-[40px] flex flex-col">
                  <p className="w-[125px] h-[24px] font-semibold text-[16px]">
                    Product Inquiry
                  </p>
                  <hr className="w-[184px] h-[3px] rounded-full bg-[#FF6300] mt-[13px]" />

                  <div className="mt-[18px] flex flex-row gap-x-[21px]">
                    <div className="w-[118px] h-[98px] bg-white flex items-center justify-center rounded-[5px] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
                      <img
                        src={selectedProduct?.images[0]}
                        alt=""
                        className="w-[48px] h-[60px]"
                      />
                    </div>

                    <div className="w-full flex justify-between">
                      <div className="flex flex-col gap-y-[11px] text-start items-start justify-center w-[500px]">
                        <p className="w-[500px] h-[21px] font-semibold text-[14px]">
                          {selectedProduct?.productTitle}
                        </p>
                        <p className="text-[12px] font-medium">
                          Seller : {selectedProduct?.storeName}
                        </p>
                      </div>

                      <div className="flex flex-col gap-y-[9px] justify-center items-end w-[150px]">
                        <div className="w-[55px] h-[18px] font-medium text-[12px] gap-x-[5px] flex items-center justify-end">
                          {FeaturedProductPriceTagSVG}
                          <p className="">Price :</p>
                        </div>
                        <p className="w-[150px] h-[21px] font-semibold text-[14px] text-end">
                          {getCurrencySymbol()}{" "}
                          {calculatedPrice(selectedProduct?.maxPrice)} /{" "}
                          {calculatedPrice(selectedProduct?.productType)
                            ? calculatedPrice(selectedProduct.productType)
                            : "Unit"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="px-[40px] w-[869px] h-[455px] pt-[46px]">
                  <div className="flex flex-row gap-x-[22px]">
                    <div className="gap-y-[10px] flex flex-col">
                      <p className="w-[124px] h-[21px] font-semibold text-[14px] text-black">
                        Product Quantity
                      </p>
                      <input
                        type="text"
                        value={inquiryQuantity}
                        onChange={(e) => setInquiryQuantity(e.target.value)}
                        placeholder="Enter product quantity"
                        className="w-[248px] h-[41px] border rounded-[5px] placeholder:text-[#979797] placeholder:text-[14px] placeholder:font-medium p-[10px] font-medium text-[14px]"
                      />
                    </div>

                    <div className="gap-y-[10px] flex flex-col">
                      <p className="w-[124px] h-[21px] font-semibold text-[14px] text-black">
                        Email ID
                      </p>
                      <input
                        type="text"
                        value={inquiryEmail}
                        onChange={(e) => setInquiryEmail(e.target.value)}
                        placeholder="Enter your email ID"
                        className="w-[248px] h-[41px] border rounded-[5px] placeholder:text-[#979797] placeholder:text-[14px] placeholder:font-medium p-[10px] font-medium text-[14px]"
                      />
                    </div>

                    <div className="gap-y-[10px] flex flex-col">
                      <p className="w-[124px] h-[21px] font-semibold text-[14px] text-black">
                        Contact No.
                      </p>
                      <input
                        type="text"
                        value={inquiryContact}
                        onChange={(e) => setInquiryContact(e.target.value)}
                        placeholder="Enter your contact no."
                        className="w-[248px] h-[41px] border rounded-[5px] placeholder:text-[#979797] placeholder:text-[14px] placeholder:font-medium p-[10px] font-medium text-[14px]"
                      />
                    </div>
                  </div>

                  <div className="gap-y-[10px] flex flex-col mt-[28px]">
                    <p className="w-[50px] h-[21px] font-semibold text-[14px] text-black">
                      Inquiry
                    </p>
                    <textarea
                      name="Inquiry"
                      id="Inquiry"
                      rows={5}
                      value={inquiryContent}
                      onChange={(e) => setInquiryContent(e.target.value)}
                      placeholder="Tell us what else do you want to know about the product"
                      className="w-[789px] h-[149px] p-[10px] border rounded-[5px] placeholder:text-[#979797] placeholder:text-[14px] placeholder:font-medium font-medium text-[14px] text-black resize-none"
                    ></textarea>
                  </div>

                  <div className="flex items-center justify-center gap-x-[19px] w-full h-[42px] flex-row  mt-[50px]">
                    <button
                      className="w-[162px] h-[42px] bg-[#FF6300] font-semibold text-[14px] rounded-[5px] text-white"
                      onClick={toggleSubmitButton}
                    >
                      Send Inquiry
                    </button>
                    <button
                      className="w-[120px] h-[42px] rounded-[5px] text-black font-semibold text-[14px] border"
                      onClick={handleCloseInquiryForm}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {showForm3 && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded-[10px] w-[869px] h-[434px] flex flex-col pt-[65px] pb-[51px] items-center justify-center gap-y-[32px]">
              <p className="w-[98px] h-[98px] bg-[#0097B2] rounded-full flex items-center justify-center">
                {FeaturedProductSendTickSVG}
              </p>
              <h3 className="w-[113px] h-[24px] font-semibold text-[16px] text-black text-start">
                Inquiry Sent !!
              </h3>
              <p className="w-[305px] h-[52px] font-medium text-[14px] text-black text-center">
                Your inquiry has been sent to the seller. We will notify you
                once the seller responds.
              </p>
              <div className="w-full h-[42px] flex flex-row gap-x-[19px] items-center justify-center">
                <button
                  className="w-[162px] h-[42px] bg-[#FF6300] rounded-[5px] text-white font-semibold text-[14px]"
                  onClick={handleViewAllInquiries}
                >
                  View All Inquiries
                </button>
                <button
                  className="w-[120px] h-[42px] rounded-[5px] text-black font-semibold text-[14px] border"
                  onClick={handleCloseInquirySent}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default FeatureSlide;
